export const TOKEN_UNIT = '1';
export const SLIPPAGE_TOLERANCE = 0.3;
export const TOKEN_A_AMOUNT_MIN = 1;
export const TOKEN_B_AMOUNT_MIN = 0.000001;
export const INPUT_STEP = 0.000001;
export const TOKENS_MAX = 9999999999;
export const FRACTIONAL_DIGITS = 12;
export const ZERO_VALUE = 0;
export const ANIMATION_DURATION = 300;
export const MULTIPLIER = 1 - SLIPPAGE_TOLERANCE / 100; // 0.997
export const RATE_UPDATE_INTERVAL = 10000; // 10 sec

// Input validation limits
export const MIN_INTEGER_DIGITS = 1;
export const MAX_INTEGER_DIGITS = 10;
